import { render, staticRenderFns } from "./the-header.vue?vue&type=template&id=2a8d53f2&scoped=true&"
import script from "./the-header.vue?vue&type=script&lang=ts&"
export * from "./the-header.vue?vue&type=script&lang=ts&"
import style0 from "./the-header.vue?vue&type=style&index=0&id=2a8d53f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8d53f2",
  null
  
)

export default component.exports